"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSrcPlane = void 0;
var getSrcPlane = function (chart) {
    var yMax = chart.yAxis.fixMaxExtend || chart.yAxis.fixMax;
    if (yMax && chart.yAxis.fixStep) {
        return [
            [
                [
                    0,
                    0
                ],
                [
                    chart.xAxis.series.length,
                    0
                ]
            ],
            [
                [
                    0,
                    0,
                ],
                [
                    0,
                    yMax
                ]
            ],
        ];
    }
    var values = [];
    if (chart.type === 'range') {
        var pairs = chart.values.map(function (it) { return it.series; })[0];
        values = pairs.reduce(function (acc, it) { return acc.concat(it); }, []);
    }
    else if (chart.type === 'line' || chart.type === 'multibar') {
        values = [];
        chart.values.forEach(function (it) { return it.series.forEach(function (it2) {
            var value = Number(it2);
            values.push(value);
        }); });
    }
    else {
        var valuesGroup_1 = chart.values.map(function (it) { return it.series; });
        values = Array.from(new Array(valuesGroup_1[0].length))
            .map(function (_, i) { return Array.from(new Array(valuesGroup_1.length))
            .map(function (__, j) { return valuesGroup_1[j][i]; })
            .reduce(function (acc, it) { return acc + it; }, 0); });
    }
    if (chart.yAxis.ignoreZeroPoint) {
        values = values.filter(function (it) { return it !== 0; });
    }
    var min = chart.yAxis.zeroBased ? 0 : Math.min.apply(Math, values);
    var max = Math.max.apply(Math, values);
    var paddingScale = chart.paddingScale || 10;
    var padValue = (max - min) / paddingScale;
    min = chart.yAxis.zeroBased ? min : Math.round((min - padValue) * 100) / 100;
    max = Math.round((max + padValue) * 100) / 100;
    return [
        [
            [
                0,
                0
            ],
            [
                chart.xAxis.series.length,
                0
            ]
        ],
        [
            [
                0,
                min
            ],
            [
                0,
                max
            ]
        ],
    ];
};
exports.getSrcPlane = getSrcPlane;
